import script from "./CTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTable.vue?vue&type=script&setup=true&lang=ts"

import "./CTable.vue?vue&type=style&index=0&id=3a2e2576&scoped=true&lang=scss"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a2e2576"]])

export default __exports__